/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Input } from '@angular/core';
import { decode } from 'html-entities';

@Component({
  selector: 'fal-more-hours-card',
  templateUrl: './more-hours-card.component.html',
  styleUrls: ['./more-hours-card.component.scss']
})
export class MoreHoursCardComponent {
  showModal = false;
  @Input() labHourSets = [];
  @Input() moreHours: string[] = [];
  @Input() holidayHours: string[] = [];
  constructor() {}

  showMoreHours(): void {
    this.showModal = true;
  }

  hideMoreHours(): void {
    this.showModal = false;
  }

  isShowMoreHoursLink(): boolean {
    return (
      (this.labHourSets && this.labHourSets.length > 0 && this.labHourSets[0] !== '') ||
      (this.moreHours && this.moreHours.length > 0 && this.moreHours[0] !== '') ||
      (this.holidayHours && this.holidayHours.length > 0 && this.holidayHours[0] !== '')
    );
  }

  decodeHtml(decodeStr: string) {
    return decode(decodeStr);
  }
}
